import { Injectable } from '@angular/core';
import { WebrtcInitOptions } from '@edtech-ui/core/models/ai-interview/webrtc';

@Injectable({
  providedIn: 'root',
})
export class WebrtcService {
  private pc?: RTCPeerConnection;
  public dc?: RTCDataChannel;
  private remoteStream = new MediaStream();
  private isClosed = false;

  async connect(opts: WebrtcInitOptions): Promise<MediaStream> {
    try {
      this.isClosed = false;
      this.pc = new RTCPeerConnection(opts.webrtcConfig);

      this.pc.ontrack = (event) => {
        event.streams[0].getTracks().forEach((t) => this.remoteStream.addTrack(t));
        opts.onTrack?.(event);
      };

      if (opts.localStream) {
        opts.localStream.getTracks().forEach((track) => this.pc!.addTrack(track, opts.localStream!));
      }

      this.dc = this.pc.createDataChannel('oai-events', { ordered: true });
      this.dc.onopen = () => { this.flushQueue(); };
      this.dc.onclose = () => {};
      this.dc.onerror = (err) => console.error('[WebRTC] DataChannel error:', err);
      if (opts.onMessage) {
        this.dc.onmessage = (e) => opts.onMessage!(e);
      }

      const offer = await this.pc.createOffer({ offerToReceiveAudio: true, offerToReceiveVideo: false });
      await this.pc.setLocalDescription(offer);

      const res = await fetch(`${opts.apiUrl}`, {
        method: 'POST',
        body: offer.sdp,
        headers: {
          Authorization: `Bearer ${opts.ephemeralToken}`,
          'Content-Type': 'application/sdp',
        },
      });

      if (!res.ok) throw new Error(`Failed to connect: ${res.statusText}`);

      const answerSdp = await res.text();
      await this.pc.setRemoteDescription({ type: 'answer', sdp: answerSdp });

      return this.remoteStream;
    } catch (err) {
      this.close();
      throw err;
    }
  }

private sendQueue: string[] = [];

send(data: any) {
  if (this.isClosed) return;

  const payload = JSON.stringify(data);

  if (this.dc?.readyState === 'open') {
    this.dc.send(payload);
  } else {
    this.sendQueue.push(payload);
  }
}

private flushQueue() {
  if (!this.dc || this.dc.readyState !== 'open') return;

  while (this.sendQueue.length) {
    this.dc.send(this.sendQueue.shift()!);
  }
}


  close() {
    if (this.isClosed) return;
    this.isClosed = true;

    try {

      this.dc?.close();
      this.pc?.getSenders().forEach((s) => s.track?.stop());
      this.pc?.getReceivers().forEach((r) => r.track?.stop());
      this.pc?.close();
      this.remoteStream.getTracks().forEach((t) => t.stop());

      this.pc = undefined;
      this.dc = undefined;
      this.remoteStream = new MediaStream();

    } catch (err) {
    }
  }
}
